import { Component } from "react";

class LoginPageNavbar extends Component {
    render() {
        return (
            <div className="flex z-10 w-full min-h-12 border-b-1 fixed bg-gray-50">
                <div className="flex-1 flex items-center justify-start pl-4">
                    <img className="max-w-10" src="/images/RashacLogo.png" alt="user" />
                </div>
                <div className="flex-1 flex items-center justify-end pr-4">
                    <img src="/images/profile.svg" className="max-w-8" alt="logo" />
                </div>
            </div>
        );
    }
}

export default LoginPageNavbar;
